export function getDataSource(symbol: string) {
  const upperSymbol = symbol.toUpperCase()
  
  // Check for crypto symbols (Binance patterns)
  if (upperSymbol.endsWith('USDT') || upperSymbol.endsWith('BTC') || 
      upperSymbol.endsWith('ETH') || upperSymbol.endsWith('BNB') ||
      upperSymbol.includes('USDT') || upperSymbol.includes('BTC') || 
      upperSymbol.includes('ETH') || upperSymbol.includes('BNB')) {
    return 'binance'
  }
  
  // Check for Indian stock symbols
  if (upperSymbol.endsWith('.NS') || upperSymbol.endsWith('.BS')) {
    return 'yahoo'
  }
  
  return 'yahoo' // default to yahoo
}
